import React, { useEffect, useState } from "react";
import { PhotoSlider } from "react-photo-view";

type PreviewProps = {
  url: string;
  visible: boolean;
  close: () => void;
};

const Preview: React.FC<PreviewProps> = (props) => {
  const [visible, setVisible] = useState(false);
  const [previewIndex, setPreivewIndex] = useState(0);

  useEffect(() => {
    setVisible(props.visible);
  }, [props.visible]);

  const cancelControl = () => {
    setVisible(false);
    props.close();
  };

  return <PhotoSlider
      photoClosable
      images={[{src: props.url}]}
      visible={visible}
      onClose={cancelControl}
      index={previewIndex}
      onIndexChange={ (i: number)=> setPreivewIndex(i)}
    />
}

export default Preview;
